import { useCallback, useEffect, useRef, useState } from 'react';

export function useCopyToClipboard(resetMs = 2000) {
  const [copied, setCopied] = useState(false);
  const timeoutRef = useRef<number | undefined>(undefined);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  const copy = useCallback(
    async (text: string) => {
      if (!navigator?.clipboard?.writeText) {
        console.warn('Clipboard API not available');
        return false;
      }
      try {
        await navigator.clipboard.writeText(text);
        setCopied(true);
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = window.setTimeout(() => setCopied(false), resetMs);
        return true;
      } catch (err) {
        console.error('Failed to copy:', err);
        return false;
      }
    },
    [resetMs],
  );

  return { copied, copy };
}
